<template>
  <b-modal
    id="update-ftp-modal"
    v-model="openModal"
    size="lg"
    title="Mise à jour du fichier"
    static
  >
    <ValidationObserver ref="formValidator">
      <FTPCreator
        :resource="resource"
      />
    </ValidationObserver>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="cancel"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          @click="confirmUpdate"
        >
          {{ $t('buttons.confirm') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import FTPCreator from '@/components/Resource/creators/FTPCreator.vue';
import { validateFormAndScroll } from '@/utils';
import { ValidationObserver, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'UpdateFTPResourceModal',

  components: {
    FTPCreator,
    ValidationObserver,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: null
    },
    format: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      openModal: false,
    };
  },

  watch: {
    open: function(newValue) {
      this.openModal = newValue;
    }
  },

  created() {
    this.openModal = true;
  },

  methods: {
    cancel() {
      this.$emit('hide');
    },

    async confirmUpdate() {
      const isValid = await validateFormAndScroll(this.$refs.formValidator, this);
      if (isValid) {
        this.updateFTPResource();
      }
    },

    updateFTPResource() {
      this.$emit('update', this.resource);
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less" scoped>

h2 {
  color: @blue;
  margin-top: 0.8em;
  margin-left: 0.5em;
}

p {
  margin-left: 1em;
  font-size: 1.1em;
  font-weight: 500;
}

</style>
